const Profile = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(-0.243)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4246)">
        <g transform="translate(-635.757 4246)">
          <g transform="translate(0.757 1)">
            <g transform="translate(0)">
              <path
                d="M14.439,10.936A8.426,8.426,0,0,0,11.225,8.92a4.89,4.89,0,1,0-5.533,0,8.472,8.472,0,0,0-5.692,8H1.322a7.137,7.137,0,0,1,14.273,0h1.322A8.4,8.4,0,0,0,14.439,10.936ZM8.458,8.458A3.568,3.568,0,1,1,12.027,4.89,3.572,3.572,0,0,1,8.458,8.458Z"
                transform="translate(0)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Profile;
